export default "__VITE_ASSET__8de8353a__"